var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_417_2276",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_417_2276",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADCUlEQVR4nO2dTW4TQRBGH4gTcAMk34FcAokFCTEB8nMFDsDNiK+QAwQJiSUgdixwCIshkpn/Hle7qme+J7WUyJ12uZ+6erqi8YAQQgghhBBCxOM5sAHua+0WWKl/cv+9uW55s4d2o/7J/Xt5PKLP057Xfqh/cv+9WVEtv7r9DdVyVf+0/sKZFVXq+gQcOcci+H/1XA91fpQ9HHFf+713zsds6uKAjBGiHBiMpBwoGtSvvuINuDB2D463FgNKyH4cUaX7G4xKKaUK+Qj8orusYdUOjnsAE3gG/CG/DPP5GHOVtdn5+bN1AJm48w4gJ+Y58EB8AH5S2AoRwxwDv5kuROc4Q4ZkjBGic5wRJzRltMkZQinOgFc0J38LrAkgZGk58DXtK+P43+vuQpaUA09pl3Gy08ddyFJy4ClVWuqTAenzoVrWBNaMkwHp86FaViJtV1Nb4Kyjv/t8uAeQkVQZEGA+zHNgEM5opqkt1V7Sh7uQUmtZfbylXcZ6xN+6C5kb75guA9KFLO0cl0SXjDcJY6iWZUTboW9Llb5ScD8YzoG2Q9+WasWk4i6k9Bx4TvUfxH1XxgPuQkrOgRfYyoAAQkrNgZe0y5iSpnZRLWsCuWRA+nwsvpZ1RVPGHfDeaPyvO+N+MRoziZKE5JYB8BL4BnwHXhiOO5pSalldMs49g8pBCbWsLhkXnkHlop6ySmiRZJif47wnd4qMS4sPboT5Oc57glPblcWHNqQeXy9jbvocHCQY0W5krc9fb3xPJrxB9A9cNLoLNxgSkh/z+2uSNiUHoseXdI6bsqlH30OixZeEUlYwJCQYEhIMCclP9lpWNKLHZ/59WdGvYmYVn1JWMCQkGBISDAnJj2pZwVAtyyUKI5SygiEhwZCQYEhIflTLCoZqWS5RdKNaVslISDAkJBgSkh/VsoKhWpZLFEYoZQVDQoIhIcGQkPyolhUM1bJcouhGtaySmSLE+y7boRQ1u+en1/Ge8NQW7fnpSXvcHFNWtOenZ69lRW/Rnp9ewnfFCCGEEEIIIRbMX78z+n7eaQ9lAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptional);
export default __webpack_public_path__ + "static/media/optional.df8818f1bfbf98653955358ee0c089cf.svg";
export { ForwardRef as ReactComponent };